<template>
  <div id="app">
    <!-- 导航栏 -->
    <div class="nav">
      <!-- logo -->
      <img src="./assets/about/1nmoblogo.png" />
      <!-- tab -->
      <div class="nav_tab">
        <div :class="[ activeIndex === 'Home' ? 'active' : '']" @click="homeTab">首页</div>
        <div :class="[ activeIndex === 'About' ? 'active' : '']" @click="aboutTab">关于我们</div>
      </div>
    </div>
    <Home  style="margin-top:72px;"></Home>
    <About></About>
    <footer>
      杭州壹恩数字科技有限公司 版权所有
      <a href="http://beian.miit.gov.cn" target="_blank">浙ICP备19034210号-1</a>
    </footer>
  </div>
</template>

<script>
  import Home from './components/Home.vue'
  import About from './components/About.vue'

  export default {
    name: 'app',
    components: {
      Home,
      About
    },
    data () {
      return {
        activeIndex: 'Home'
      }
    },
    methods: {
      homeTab () {
        this.activeIndex = 'Home'
      },
      aboutTab () {
        this.activeIndex = 'About'
      }
    }
  }
</script>

<style lang="less">
  html,
  body{
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: PingFang SC;
  }

  .nav {
    background: #fff;
    height: 72px;
    padding: 0 20%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      display: inline-block;
      width: 100px;
    }
    .nav_tab {
      position: relative;
      display: flex;
      flex-direction: row;
      height: 72px;
      line-height: 80px;
      font-size: 18px;
      margin-right: 0px;
      div {
        width: 120px;
        padding: 0 8px;
        text-align: center;
        &:hover {
          cursor: pointer;
        }
      }
      .active {
        color: #9a2fee;
        border-bottom: 4px solid #9a2fee;
      }
    }
  }
  footer {
    text-align: center;
    height: 158px;
    line-height: 158px;
    background-color: #1e0f29;
    color: #ccc;
    font-size: 20px;
    a {
      color: #ccc;
    }
  }
</style>
